<style lang="scss" type="text/scss">
  div {
    border-radius: 4px;
    background: #4e4e4e;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: auto;

    box-shadow: -1px 0 30px -4px rgba(0, 0, 0, 0.15);
    margin: 30px 0 56px 0;
    padding: 8px 12px;

    transition: background 0.3s;

    svg {
      width: 20px;
      height: 20px;
      display: inline-block;
      opacity: 0.8;

      .a {
        stroke: #fff;
      }
    }

    cursor: pointer;
  }

  div:hover {
    background: #ef5442;
  }

  span {
    display: inline-block;
    margin-left: 12px;
    color: #fff;
    font-family: proxima-nova, sans-serif;
    font-size: 12px;
    font-weight: 700;
  }
</style>

<script>
  export let label = '';
</script>

<div class="button" on:click>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <defs>
      <style>
        .a {
          fill: none;
          stroke: #000;
          stroke-linecap: round;
          stroke-linejoin: round;
          stroke-width: 1.5px;
        }
      </style>
    </defs>
    <title>bin</title>
    <path
      class="a"
      d="M17.25,21H6.75a1.5,1.5,0,0,1-1.5-1.5V6h13.5V19.5A1.5,1.5,0,0,1,17.25,21Z"
    ></path>
    <line class="a" x1="9.75" y1="16.5" x2="9.75" y2="10.5"></line>
    <line class="a" x1="14.25" y1="16.5" x2="14.25" y2="10.5"></line>
    <line class="a" x1="2.25" y1="6" x2="21.75" y2="6"></line>
    <path
      class="a"
      d="M14.25,3H9.75a1.5,1.5,0,0,0-1.5,1.5V6h7.5V4.5A1.5,1.5,0,0,0,14.25,3Z"
    ></path>
  </svg>

  <span>{label}</span>
</div>
